import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../../loader/loader.service';
import { AuthService } from 'src/app/core/service/auth.service';
import { Router } from '@angular/router';

// import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
// import { Keepalive } from '@ng-idle/keepalive';
@Component({
	selector: 'app-main-layout',
	templateUrl: './main-layout.component.html',
	styleUrls: []
})
export class MainLayoutComponent implements OnInit {
	show = true;
	fullScreen = true;
	template = ``;
	idleState = 'Not started.';
	timedOut = false;
	lastPing?: Date = null;
	title = 'angular-idle-timeout';
	constructor(
		public loaderService: LoaderService,
		// private idle: Idle,
		// private keepalive: Keepalive,
		private authService: AuthService,
		private router: Router
	) {
		// // sets an idle timeout of 3 hours.
		// idle.setIdle(10800);
		// // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
		// idle.setTimeout(10);
		// // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
		// idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
		// idle.onIdleEnd.subscribe(() => {
		// 	this.idleState = 'No longer idle.';
		// 	// console.log(this.idleState);
		// 	this.reset();
		// });
		// idle.onTimeout.subscribe(() => {
		// 	this.idleState = 'Timed out!';
		// 	this.timedOut = true;
		// 	this.clearSessionDetails();
		// });
		// idle.onIdleStart.subscribe(() => {
		// 	this.idleState = "You've gone idle!";
		// 	// console.log(this.idleState);
		// 	// this.childModal.show();
		// });
		// idle.onTimeoutWarning.subscribe((countdown) => {
		// 	this.idleState = 'You will time out in ' + countdown + ' seconds!';
		// 	console.log(this.idleState);
		// });
		// // sets the ping interval to 15 seconds
		// keepalive.interval(15);
		// keepalive.onPing.subscribe(() => (this.lastPing = new Date()));
		// this.reset();
	}

	// reset() {
	// 	this.idle.watch();
	// 	this.idleState = 'Started.';
	// 	this.timedOut = false;
	// }

	// method to clear user session
	// clearSessionDetails() {
	// 	this.authService.logout().subscribe((res) => {
	// 		if (!res.success) {
	// 			this.router.navigate([ '/authentication/signin' ]);
	// 		}
	// 	});
	// }

	ngOnInit(): void {
		// this.spinner.show();
		// setTimeout(() => {
		// 	/** spinner ends after 5 seconds */
		// 	this.spinner.hide();
		// }, 5000);
		// this.ngxLoader.start();
	}
}
